import { HandRaisedIcon } from '@heroiconsv2/react/24/outline'
import { LABEL, ROW, ROW_START, SectionCard } from './BookingSection'
import { getAcknowledgmentStatusTranslation } from '../bookingDetailHelpers'

const BookingAcknowledgmentCard = ({ bookingData, t }) => {
  if (!bookingData?.acknowledgment?.length) return null

  return (
    <SectionCard icon={HandRaisedIcon} title={t('booking.sections.acknowledgmentDetails')}>
      <div>
        <div className="flex flex-col w-full space-y-3">
          {bookingData.acknowledgment.map((ack, index) => (
            <div key={index} className="rounded-xl border border-slate-200/80 bg-slate-50/30 px-4 py-1">
              <div className={ROW}>
                <div className={LABEL}>{t('booking.labels.status')}</div>
                <div
                  className={`text-xs font-semibold tracking-wide px-2.5 py-1 rounded-full inline-flex items-center shadow-sm ring-1 ${
                    ack.status === 'handover'
                      ? 'bg-emerald-100 text-emerald-800 ring-emerald-200/60'
                      : ack.status === 'not handover'
                      ? 'bg-red-100 text-red-800 ring-red-200/60'
                      : 'bg-amber-100 text-amber-900 ring-amber-200/60'
                  }`}
                >
                  {getAcknowledgmentStatusTranslation(t, ack.status)}
                </div>
              </div>

              {ack.message && (
                <>
                  <div className={ROW_START}>
                    <div className={LABEL}>{t('booking.labels.title')}</div>
                    <div className="text-sm sm:text-base text-slate-800 sm:text-right break-words flex-1">{ack.message.title?.en || '-'}</div>
                  </div>

                  <div className={ROW_START}>
                    <div className={LABEL}>{t('booking.labels.description')}</div>
                    <div className="text-sm sm:text-base text-slate-800 sm:text-right break-words flex-1">{ack.message.description?.en || '-'}</div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </SectionCard>
  )
}

export default BookingAcknowledgmentCard
